import React from 'react';

export type CardVariant = 'elevated' | 'flat' | 'glass';

export interface MPCardProps {
  variant?: CardVariant;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  children: React.ReactNode;
}

const variantClasses: Record<CardVariant, string> = {
  elevated: [
    'mp-tw-bg-mp-card mp-tw-text-mp-text',
    'mp-tw-rounded-mp-xl',
    'mp-tw-shadow-mp-elevated',
    'mp-tw-border mp-tw-border-transparent',
  ].join(' '),
  flat: [
    'mp-tw-bg-mp-card mp-tw-text-mp-text',
    'mp-tw-rounded-mp-xl',
    'mp-tw-border mp-tw-border-solid mp-tw-border-mp-border',
  ].join(' '),
  glass: [
    'mp-glass',
    'mp-tw-text-white',
    'mp-tw-rounded-mp-xl',
    'mp-tw-shadow-mp-premium',
  ].join(' '),
};

const paddingClasses = {
  none: '',
  sm: 'mp-tw-p-4',
  md: 'mp-tw-p-6',
  lg: 'mp-tw-p-8',
};

const MPCard: React.FC<MPCardProps> = ({
  variant = 'elevated',
  padding = 'md',
  className = '',
  children,
}) => {
  const classes = [
    variantClasses[variant],
    paddingClasses[padding],
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default MPCard;
